import * as React from "react";
import Layout from "./Layout";
import { Box, Container, Link, Typography } from "@mui/material";
import Results from "./Results";

const BobrovnikPage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h2">
                    Od Technických služeb až na Bobrovník
                </Typography>
                <Typography variant={"h4"} component={"h2"} gutterBottom>
                    5. segment - říjen
                </Typography>
                <ul>
                    <li>
                        <Link href={"https://www.strava.com/segments/24211135"}>
                            Segment na webu STRAVA
                        </Link>
                    </li>
                    <li>
                        <Link href={"https://www.relive.cc/view/vAOZByzjkoO"}>
                            Video ukázka
                        </Link>
                    </li>
                </ul>
                <Typography gutterBottom>
                    Pokračujeme městským během skrz město Jeseník. Připravte se
                    na pevný podklad a mírně vzrůstající profil trati. Půjde o
                    4,6 km, které povedou většinu své trasy po cyklo trase –
                    Moravské stezky. Nicméně Vás čeká řada přeběhů přes
                    frekventované cesty, kooperaci s chodníkem apod. Berte
                    prosím v potaz zejména Vaše zdraví a dodržujte stanovené
                    dopravní předpisy.
                </Typography>

                <Box
                    component={"ul"}
                    sx={{ marginTop: (theme) => theme.spacing(2) }}
                >
                    <li>
                        START – je na úrovní sídla Technických služeb Jeseník
                        (jejich areálu), tedy začátku ulice Otakara Březiny. V
                        místě, kde je dopravní značka jednosměrky je pomyslný
                        start a zde už můžete běžet závodním tempem. Běžíte
                        směrem do města – tedy po směru jednosměrky automobilů.
                    </li>
                    <li>
                        Po 1. kilometru po této ulici přibíháte k budově ZUŠ a
                        odbočce k Minipivovaru Jeseník. Zde tedy odbočíte
                        doprava a pokračujete dále už po cyklotrase. Proběhnete
                        tedy areálem Minipivovaru Jeseník (v případě potřeby
                        občerstvíte) a vybudovanou stezkou pokračujete k ulici
                        Tyršova. Zde probíhá rekonstrukce ulice, takže dávejte
                        pozor, nicméně Vaším cílem je ulici Tyršovu jen křižovat
                        a pokračovat dále rovně. Dostanete se na ulici Lipovská,
                        zde využijte přechodu pro chodce a pokračujte dále po
                        cyklotrase podél řeky. Oběhnete kolem stromu a už se
                        blížíte k zadní části sídliště na Lipovské. Po dřevěné
                        lávce přeběhnete řeku Staříč a pokračujete až za areál
                        Mka. Cyklotrasa vede za garážemi a dostanete se ke
                        křižování ulice u Bělidla. Zamíříte k bikrosové dráze a
                        již Vás čeká viadukt. Hned za ním míříte vpravo stále po
                        cyklotrase. Opatrně na kruhovém objezdu, který je
                        posledním místem se setkání dopravních prostředků.
                        Následně Vás čeká lahodný závěr v přírodě a kopcem k
                        areálu Bobrovníku.
                    </li>
                    <li>
                        CÍL – je na začátku areálu Bobrovník - za horizontem
                        kopce, přičemž v místě cíle je zábrana pro vjezd aut na
                        cyklotrasu.
                    </li>
                </Box>
                <Results segmentId={"3-6-24211135"} />
            </Container>
        </Layout>
    );
};

export default BobrovnikPage;
